<script setup>
import { ref, computed, onMounted, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import ModuleContainer from "./views/ModuleContainer.vue";
import Leaderboard from "./views/Leaderboard.vue";
import SeasonStandings from "./views/SeasonStandings.vue";
import FavoriteDrivers from "./views/FavoriteDrivers.vue";
import Map2d from "./views/Map2d.vue";
import ToastOverlay from "./views/ToastOverlay.vue";
import TheChase from "./views/TheChase.vue";
import LapCounterBar from "./views/LapCounterBar.vue";
import axios from 'axios';
import toast from "./js/toast.js";
import InitialLoader from "./views/InitialLoader.vue";

// Basic lazy loading using a dynamic import
const LazyLoaded = defineAsyncComponent(() =>
  import('./views/LazyLoaded.vue')
)

// grab state
const store = useStore();
const initialFadeIn = ref(false);
const serverURL = "https://nascar-meta-display-poc.onrender.com";

const infoDisplayIndex = ref(0);
const infoDisplayData = ref([0,1,2,3]);
const infoDisplayNames = ref([
  "Leaderboard",
  "Favorite Driver",
  "Live Map",
  "Season Standings",
])
const infoDisplayTransition = ref("right-to-left");

const minimzedTransition = computed(() => {
  return store.getters.isAppMinimized ? `to-minimized` : `from-minimized`;
});

const onScreenChanged = async () => {
  const body = {
    name: `MRBD-${deviceID.value}`,
    screen: infoDisplayNames.value[infoDisplayIndex.value]
  }
  //const response = await axios.post(`${serverURL}/api/updateDevice`, body)
  //console.log(response);
}

const deviceID = ref("");
const generateID = () => {
  let deviceIDFromStorage = localStorage.getItem('deviceID');
  if (deviceIDFromStorage == null) {
    deviceIDFromStorage = Math.random().toString(36).substring(2, 9);
    localStorage.setItem('deviceID', deviceIDFromStorage)
  }
  deviceID.value = deviceIDFromStorage;
  window.deviceID = deviceIDFromStorage;
  console.log(`DEVICE ID: ${deviceIDFromStorage}`)
}

const scrollLeft = () => {
  infoDisplayTransition.value = "right-to-left";
  infoDisplayIndex.value++;
  if (infoDisplayIndex.value >= infoDisplayData.value.length) {
    infoDisplayIndex.value = 0;
  }
  onScreenChanged();
}

const scrollRight = () => {
  infoDisplayTransition.value = "left-to-right";
  infoDisplayIndex.value--;
  if (infoDisplayIndex.value < 0) {
    infoDisplayIndex.value = infoDisplayData.value.length - 1
  }
  onScreenChanged();
}

const startLazyLoad = ref(false);
onMounted(() => {
  generateID();
  onScreenChanged();
  startLazyLoad.value = true;


  window.addEventListener("to-minimized", async (event) => {
    store.commit('isAppMinimized', !store.getters.isAppMinimized)
    if(store.getters.isAppMinimized){
      const body = {
        name: `MRBD-${deviceID.value}`,
        screen: "Minimized"
      }
      //const response = await axios.post(`${serverURL}/api/updateDevice`, body)
      //console.log(response);
    } else {
      onScreenChanged();
    }
    
  });

  window.addEventListener("right-scroll", (event) => {
    scrollLeft()
  });

  window.addEventListener("left-scroll", (event) => {
    scrollRight()
  });

  initialFadeIn.value = true;
})

</script>

<template>
  <div>
    <Transition :name="minimzedTransition" mode="out-in">
      <LapCounterBar v-if = "store.getters.isAppMinimized" key="minimized-app"></LapCounterBar>
      <div class="full-container" v-else key = "full-app">
        <Transition name="fade" mode="out-in">
          <div class="absolute-fill" v-if="initialFadeIn" key="other">
            <transition :name="infoDisplayTransition" mode="out-in">
              <ModuleContainer key="module-0" title="" v-if="infoDisplayIndex == 0">
                <transition name="fade">
                  <Leaderboard key="leaderboard" />
                </transition>
              </ModuleContainer>
              <ModuleContainer key="module-4" title="" v-else-if="infoDisplayIndex == 1">
                <FavoriteDrivers />
              </ModuleContainer>
              <ModuleContainer key="module-3" title="" v-else-if="infoDisplayIndex == 2">
                <Map2d />
              </ModuleContainer>
              <ModuleContainer key="module-2" title="" v-else-if="infoDisplayIndex == 3">
                <SeasonStandings />
              </ModuleContainer>
             
            </transition>
          </div>
        </Transition>
      </div>
    </Transition>
    <Transition name = "fade">
      <div class="pagination-area" v-if = "!store.getters.isAppMinimized">
        <div class="pagination" v-for="(pagination, index) in infoDisplayData"
          :class="{ 'active-pagination': infoDisplayIndex == index }">

        </div>
      </div>
    </Transition>
    
   
    <ToastOverlay></ToastOverlay>
    <transition name = "fade">
      <InitialLoader></InitialLoader>
    </transition>
    <LazyLoaded v-if = "startLazyLoad"></LazyLoaded>
  </div>
  
</template>

<style lang="scss" scoped>

@import './sass/GlobalClasses';
@import './sass/Settings';
@import './sass/Transitions';

.full-container{
  position: relative;
  width: vw(600);
  height:vw(600);
}

.pagination-area {
  position: fixed;
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .pagination {
    position: relative;
    width: vw(8);
    height: vw(8);
    border-radius: vw(4);
    background-color: #DFDFDF;
    margin: 0 vw(3);
  }

  .active-pagination {
    width: vw(12);
    height: vw(12);
    border-radius: vw(6);
    background-color: #FFFFFF;
  }
}

</style>
